import { UPLOADS_URL } from '../api/axios';

const CDN = 'https://www.sawsindirapuram.com/wp-content';

const applyImgResolver = (html, resolver) =>
  String(html || '').replace(/<img([^>]*?)\ssrc=["']([^"']+)["']/gi, (m, attrs, src) => {
    const resolved = resolver(src);
    return `<img${attrs} src="${resolved}"`;
  });

export const fixContentImages = (html) =>
  applyImgResolver(html, (src) => {
    if (!src) return src;
    if (src.startsWith('http')) return src;
    if (src.startsWith('/frontend/')) return src.replace('/frontend/', '/');
    if (src.startsWith('/uploads/')) return `${UPLOADS_URL}/${src.replace(/^\/uploads\//, '')}`;
    if (src.startsWith('/images/')) return `${process.env.PUBLIC_URL}${src}`;
    return src;
  });

export const fixContentLinks = (html) => {
  const CDN_URLS = ['https://www.sawsindirapuram.com/wp-content/uploads', '/wp-content/uploads', '/wp-content'];
  let out = String(html || '');
  CDN_URLS.forEach((u) => {
    out = out.split(u).join(`${UPLOADS_URL}`);
  });
  return out;
};

export const fixBlogContent = (html) => fixContentLinks(fixContentImages(html));
